export default "__VITE_ASSET__5P6i2_fr__"